import store from '@ps/store'
import _ from 'lodash'
import { addImage } from '@ps/bridge/resource/image'
import { addImageNode } from '@ps/bridge/qc/node/image'
import { executeAction, getAddAtlasAction } from '@ps/workbench/undo-redo'
import { isEraseNodeChild } from '@ps/bridge/qc/base'
import { scripts } from '@ps/bridge/qc/scripts'
import { wrapAddIvNode } from '@ps/store/interactive-video/brain/brain'

export default {
  async addImageToScene(
    { state },
    { isPool, file, fileName, fileUrl, padding, targetNode, rename },
  ) {
    // 默认添加资源到场景节点根目录，支持传入targetNode插入指定节点内
    const sceneNode =
      targetNode || store.state.workspace.sceneManager.currentSceneNode

    if (_.isEmpty(sceneNode)) {
      console.error('addImageToScene 没有场景节点')
      return
    }

    const activeNode = state.activeNode
    let node
    if (isPool) {
      // 资源池直接使用资源路径添加资源
      node = await addImageNode({
        isPool,
        files: file,
        name: fileName,
        scene: sceneNode,
        padding: '',
        nodeName: fileName,
        pid: store.state.workspace.pid,
        resourcePath: file[0].path,
        binUUID: file[0].uuid,
      })
    } else {
      node = await addImage({
        file,
        fileName,
        pid: store.state.workspace.pid,
        sceneNode,
        padding,
      })
    }

    // 添加图片节点支持rename功能
    if (rename) {
      node.name = rename
    }

    // 擦除组件节点需要添加擦除图层脚本
    if (isEraseNodeChild(node)) {
      node.addScript(scripts.eraseLayer.name)
    }

    // 由于资源池的资源会有生效时间，因此不可信任，直接用图片在项目中的地址
    // 由于沿用项目中的地址，复制项目的时候，原项目的图片地址会失效，因此需要沿用相对路径
    const img = _.get(node, 'texture.atlas.img')
    const currentSrc =
      img && typeof img.getAttribute === 'function' && img.getAttribute('src')
        ? img.getAttribute('src')
        : ''
    await store.dispatch('workspace/editorConfig/updateTargetNodeConfig', {
      originalResource: currentSrc,
      resource: currentSrc,
      node,
    })
    // index 可能为 -1。新增节点后，资源还未加载节点就被删除了，这种场景不需要继续执行接下去的逻辑
    const index = sceneNode.getChildIndex(node)

    // 互动视频编辑器插入节点处理
    const ivRes = await wrapAddIvNode(sceneNode, node, index)

    if (index >= 0) {
      await executeAction({
        action: getAddAtlasAction({
          newValue: {
            node: ivRes ? ivRes.ivGroupNode : node,
            parent: sceneNode,
            index: ivRes ? ivRes.index : index,
            realNode: node,
          },
          oldValue: {
            node: ivRes ? ivRes.ivGroupNode : node,
            activeUuid: activeNode ? activeNode.uuid : '',
          },
        }),
        record: true,
      })
      return node
    }
    return false
  },
}
